import fetchBasicActionsFor from './basicActionsFor'
import { FetchActionCreator, FetchErrorAction, FetchStartAction, FetchSuccessAction } from './model'

function fetchActionCreatorsFor<T>(resourceName: string, prefix?: string, origin?: string): FetchActionCreator<T> {
  if (resourceName === null) throw new Error('fetchActionCreatorsFor: Expected resourceName')

  const actionTypes = fetchBasicActionsFor(resourceName, prefix)

  return {
    fetchStart(): FetchStartAction {
      return {
        type: actionTypes.fetchStart,
        origin: origin
      }
    },

    fetchSuccess(resources?: T): FetchSuccessAction<T> {
      return {
        type: actionTypes.fetchSuccess,
        payload: { resources },
        origin: origin
      }
    },

    fetchError(error: any, resources?: T): FetchErrorAction<T> {
      return {
        type: actionTypes.fetchError,
        payload: { error, resources },
        origin: origin
      }
    }
  }
}

export default fetchActionCreatorsFor
